// @cs2ts-begin-auto-generated - do not modify
export const userRoles = {
    quickscan_global_admin: 'quickscan_global_admin',
    quickscan_dedicated_admin: 'quickscan_dedicated_admin',
    main_user: 'main_user',
    dedicated_user: 'dedicated_user',
    secondary_user: 'secondary_user',
};
// @cs2ts-end-auto-generated - do not modify
